import JSZip from 'jszip';

function parseCsvText(text) {
  const lines = text.split('\n');
  if (lines.length < 2) return { header: [], rows: [] };

  // Find the header line (skip LinkedIn notes/disclaimers)
  let headerLineIdx = 0;
  for (let i = 0; i < Math.min(lines.length, 10); i++) {
    const line = lines[i].toLowerCase();
    if (line.includes('first name') || line.includes('company name') ||
        (line.includes('first') && line.includes('last'))) {
      headerLineIdx = i;
      break;
    }
  }

  const header = lines[headerLineIdx].split(',').map(h => h.trim().toLowerCase().replace(/"/g, ''));

  const rows = [];
  for (let i = headerLineIdx + 1; i < lines.length; i++) {
    const line = lines[i].trim();
    if (!line) continue;

    const values = [];
    let current = '';
    let inQuotes = false;
    for (let j = 0; j < line.length; j++) {
      const char = line[j];
      if (char === '"') {
        inQuotes = !inQuotes;
      } else if (char === ',' && !inQuotes) {
        values.push(current.trim().replace(/"/g, ''));
        current = '';
      } else {
        current += char;
      }
    }
    values.push(current.trim().replace(/"/g, ''));
    rows.push(values);
  }

  return { header, rows };
}

export async function parseLinkedInZip(zipData) {
  const zip = await JSZip.loadAsync(zipData);
  let profile = null;
  let positions = [];
  let connections = [];

  // Parse Profile.csv
  const profileFile = Object.keys(zip.files).find(name =>
    name.toLowerCase().includes('profile.csv') && !name.toLowerCase().includes('summary')
  );
  if (profileFile) {
    const profileText = await zip.files[profileFile].async('string');
    const { header, rows } = parseCsvText(profileText);
    if (rows.length > 0) {
      const row = rows[0];
      const idx = (name) => header.findIndex(h =>
        h === name || h.includes(name.split(' ')[0].toLowerCase())
      );
      profile = {
        firstName: idx('first name') >= 0 ? row[idx('first name')] : '',
        lastName: idx('last name') >= 0 ? row[idx('last name')] : '',
        headline: idx('headline') >= 0 ? row[idx('headline')] : '',
        summary: idx('summary') >= 0 ? row[idx('summary')] : '',
        location: header.findIndex(h => h === 'geo location' || h.includes('location')) >= 0
          ? row[header.findIndex(h => h === 'geo location' || h.includes('location'))]
          : '',
        industry: idx('industry') >= 0 ? row[idx('industry')] : '',
      };
    }
  }

  // Parse Positions.csv
  const positionsFile = Object.keys(zip.files).find(name =>
    name.toLowerCase().includes('positions.csv')
  );
  if (positionsFile) {
    const positionsText = await zip.files[positionsFile].async('string');
    const { header, rows } = parseCsvText(positionsText);
    const companyIdx = header.findIndex(h => h === 'company name' || h.includes('company'));
    const titleIdx = header.findIndex(h => h === 'title');
    const locationIdx = header.findIndex(h => h === 'location');
    const startedIdx = header.findIndex(h => h === 'started on' || h.includes('started'));
    const finishedIdx = header.findIndex(h => h === 'finished on' || h.includes('finished'));

    positions = rows.map(row => ({
      company: companyIdx >= 0 ? row[companyIdx] : '',
      title: titleIdx >= 0 ? row[titleIdx] : '',
      location: locationIdx >= 0 ? row[locationIdx] : '',
      startDate: startedIdx >= 0 ? row[startedIdx] : '',
      endDate: finishedIdx >= 0 ? row[finishedIdx] : 'Present',
    })).filter(p => p.company || p.title);
  }

  // Parse Connections.csv
  const connectionsFile = Object.keys(zip.files).find(name =>
    name.toLowerCase().includes('connections.csv')
  );
  if (connectionsFile) {
    const connectionsText = await zip.files[connectionsFile].async('string');
    const { header, rows } = parseCsvText(connectionsText);
    const firstNameIdx = header.findIndex(h => h === 'first name');
    const lastNameIdx = header.findIndex(h => h === 'last name');
    const companyIdx = header.findIndex(h => h === 'company');
    const positionIdx = header.findIndex(h => h === 'position');
    const emailIdx = header.findIndex(h => h.includes('email'));

    connections = rows.map(row => ({
      firstName: firstNameIdx >= 0 ? row[firstNameIdx] : '',
      lastName: lastNameIdx >= 0 ? row[lastNameIdx] : '',
      company: companyIdx >= 0 ? row[companyIdx] : '',
      position: positionIdx >= 0 ? row[positionIdx] : '',
      email: emailIdx >= 0 ? row[emailIdx] : '',
    })).filter(c => c.firstName || c.lastName);
  }

  return { profile, positions, connections };
}
